import { render } from "./newsWrite.vue?vue&type=template&id=6b4b73a6&scoped=true&ts=true"
import script from "./newsWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./newsWrite.vue?vue&type=script&lang=ts&config=true"

import "./newsWrite.vue?vue&type=style&index=0&id=6b4b73a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4b73a6"]])

export default __exports__